import Cookies from 'js-cookie'

export const IS_ON_MOBILE_APP = Cookies.get('is_on_mobile_app') || false
export const GET_USER = Cookies.get('user')
export const USER_ID = Cookies.get('user_id')
